import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Spinner, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { getUserDashboard } from '../../../rtk/slices/crm-slices/userDashboard/userDashboard';

const AutoLoginHandler = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [errorModal, setErrorModal] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        // If already logged in, redirect to dashboard
        let existingToken = localStorage.getItem('token');
        if (existingToken) {
            navigate('/dashboard');
            return;
        }

        const token = searchParams.get('token');
        if (!token) {
            setErrorModal(true);
            return;
        }

        const autoLogin = async () => {
            try {
                const response = await axios.post(
                    'https://backend.pfxinvestments.com/api/auto-login',
                    { token }
                );

                console.log('auto login response', response);


                const { access_token } = response.data;

                // Store in localStorage
                localStorage.setItem('token', access_token);
                localStorage.setItem('user', JSON.stringify(user));

                // Step 2: Fetch userDashboard data
                const userDashboardResponse = await dispatch(getUserDashboard(token)).unwrap(); // Wait for userDashboard response
                const { user, trade_accounts, deposits, withdrawals, commission } = userDashboardResponse;

                // Step 3: Handle trade accounts logic
                const crmuser = JSON.parse(localStorage.getItem('crm-user')) || {};
                const localUser = JSON.parse(localStorage.getItem('user')) || {};

                if (!localUser?.account) {
                    if (trade_accounts?.length === 1) {
                        // Single trade account
                        const account = trade_accounts[0]?.account;
                        localStorage.setItem('user', JSON.stringify({ account }));
                    } else if (trade_accounts?.length > 1) {
                        // Multiple trade accounts
                        const latestAccount = trade_accounts.reduce((latest, account) => {
                            return new Date(account.created_at) > new Date(latest.created_at) ? account : latest;
                        }, trade_accounts[0]);

                        localStorage.setItem('user', JSON.stringify({ account: latestAccount.account }));
                    }
                }

                // Step 4: Store userDashboard data in localStorage
                localStorage.setItem('crm-user', JSON.stringify({ user, trade_accounts, deposits, withdrawals, commission }));

                // Step 5: Navigate to dashboard
                if (localStorage.getItem('user')) {
                    navigate('/user-dashboard');
                }
            } catch (error) {
                console.error('Auto login failed', error);
                setErrorModal(true);
            }
        };

        autoLogin();
    }, [navigate, searchParams]);

    return (
        <>
            <div
                className="auth-page-content d-flex justify-content-center align-items-center"
                style={{
                    background: '#000',
                    minHeight: '100vh',
                    color: '#fff',
                    fontSize: '18px',
                }}
            >
                <Spinner color="light" /> Logging In...
            </div>

            <Modal isOpen={errorModal} toggle={() => navigate('/login')}>
                <ModalHeader toggle={() => navigate('/login')}>Auto Login Failed</ModalHeader>
                <ModalBody>
                    The token is either invalid or expired. Please log in manually.
                </ModalBody>
            </Modal>
        </>
    );
};

export default AutoLoginHandler;
